export default __webpack_public_path__ + "static/media/2_0060.94eaea73.webp";